module.exports = __webpack_public_path__ + "img/dots.a84a7234.png";